import { LOADING_STATUS } from "@/helpers/loadingStatus";
import httpClient from "@/http/httpClient";
import store from "@/store";
import _ from "lodash";
// import { momentToString } from "ant-design-vue/es/_util/moment-util";
import moment from "moment";
export default {
  namespaced: true,
  state: {
    loadingStatus: "",
    result: [],
    selectedDealers: [],
    show: "",
    date: "",
    totalAmount: 0,
  },

  getters: {
    getParams(state) {
      const params = {};
      if (state.selectedDealers.length) {
        params["filter[id]"] = state.selectedDealers.map((x) => x).join(",");
      }

      if (state.show && state.show !== "") {
        params["show"] = state.show;
      }

      if (state.date && state.date !== "") {
        params["date"] = state.date;
      }

      return params;
    },
  },
  mutations: {
    reset(state) {
      state.totalAmount = 0;
      state.result = [];
    },
    setSelectedDealers(state, payload) {
      state.result = [];
      state.totalAmount = 0;
      state.selectedDealers = payload;
    },
    setLoadingStatus(state, payload) {
      state.loadingStatus = payload;
    },
    setResult(state, payload) {
      state.result = payload;
    },
    setShowItems(state, payload) {
      state.result = [];
      state.totalAmount = 0;
      state.show = payload;
    },
    setFilterDate(state, payload) {
      let dateString = "";
      state.result = [];
      state.totalAmount = 0;
      switch (payload) {
        case "today":
          dateString = moment().format("YYYY-MM-DD");
          break;
        case "yesterday":
          dateString = moment().subtract(1, "days").format("YYYY-MM-DD");
          break;
        case "week":
          dateString = moment().clone().startOf("isoWeek").format("YYYY-MM-DD");
          break;
        case "last_week":
          dateString = moment().subtract(1, "weeks").format("YYYY-MM-DD");
          break;
        case "month":
          dateString = moment().clone().startOf("month").format("YYYY-MM-DD");
          break;
        case "last_month":
          dateString = moment()
            .subtract(1, "months")
            .startOf("month")
            .format("YYYY-MM-DD");
          break;
        case "quarter":
          dateString = moment()
            .quarter(moment().quarter())
            .startOf("quarter")
            .format("YYYY-MM-DD");
          break;
        case "last_quarter":
          dateString = moment()
            .subtract(1, "Q")
            .startOf("Q")
            .format("YYYY-MM-DD");
          break;
        case "year":
          dateString = moment().startOf("year").format("YYYY-MM-DD");
          break;
        case "last_year":
          dateString = moment()
            .subtract(1, "years")
            .startOf("year")
            .format("YYYY-MM-DD");
          break;
        case "custom":
          dateString = dateString;
          break;
      }
      state.date = dateString;
    },
  },
  actions: {
    async fetchAllWithFilters({ commit, state, dispatch, getters }) {
      commit(
        "setLoadingStatus",
        !_.isEmpty(state.result)
          ? LOADING_STATUS.REFRESHING
          : LOADING_STATUS.FETCHING
      );
      try {
        const response = await httpClient.get("reports/sales-by-dealers", {
          params: getters.getParams,
        });
        commit("setResult", response.data.data);
        commit("setLoadingStatus", LOADING_STATUS.COMPLETED);
        return true;
      } catch (error) {
        console.error("Error on Fetch customer: ", error);
        commit("setLoadingStatus", LOADING_STATUS.FAILED);
        store.commit("errorsModal/openModal", error.response.data.errors);
        return false;
      }
    },
    calculateTotal(value) {
      this.totalAmount += value;
      return this.totalAmount;
    },
    getDateString(value) {
      let dateString = "";
      switch (value) {
        case "today":
          dateString = moment().format("MM-DD-YYYY");
          break;
      }
      return dateString;
    },
  },
};
